/**
 * We have differennt image url from legacy application
 * This function replace the url of the legacy application with microservice invitation application image url
 * @param {Image of the url} imageUrl
 * @returns
 */
const AgentImageHandler = (imageUrl) => {
    if (!imageUrl) return imageUrl;
    if (imageUrl.startsWith('/images/agents')) {
        return imageUrl.replace('/images/agents', '/contents/images/agents');
    }
    if (imageUrl.indexOf('contents/contents/images') > 0) {
        return imageUrl.replace('/contents/contents/images', '/contents/images');
    }
    if (imageUrl.indexOf('contents//images') > 0) {
        return imageUrl.replace('/contents//images', '/contents/images');
    }
    if (imageUrl.indexOf('//images') > 0) {
        return imageUrl.replace('//images', '/contents/images');
    }

    return imageUrl;
};
export default AgentImageHandler;
